module.exports = __webpack_public_path__ + "static/media/calender-icon.b5c71c16.svg";